<template>
  <div v-if="isDebitingBonuses && !isLoading && isBonusServiceActive" class="bonus-info">
    <img class="bonus-info__icon" src="/img/svgo/product-page/bonus_icon.svg" alt="bonus-icon">
    <p class="bonus-info__text">
      <span class="bonus-info__text-contrast">+{{ computedDebitingSum }} {{ [$t('bonus'), $t('bonus-2'), $t('bonus-3')] | Pluralize(computedDebitingSum) }}</span>
    </p>
    <InfoButton v-if="$t('product_bonuses_tooltip')" :tooltip-text="$t('product_bonuses_tooltip')" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Pluralize from '../../../filters/Pluralize'
import CurrencyFormatter from '../../../filters/CurrencyFormatter'
import InfoButton from '../../helpers/InfoButton'

export default {
  name: 'BonusInfo',
  components: { InfoButton },
  filters: { CurrencyFormatter, Pluralize },
  computed: {
    ...mapState({
      isDebitingBonuses: state => state.productInfo.productInfo.isDebitingBonuses,
      price: state => state.productInfo.productInfo.price,
      bonusesInfo: state => state.bonuses.bonusesInfo,
      isLoading: state => state.bonuses.isLoading,
      config: state => state.init.config
    }),
    bonusesPercent () {
      return this.bonusesInfo ? this.bonusesInfo.current_rate : 5
    },
    computedDebitingSum () {
      return Math.round((this.price * this.bonusesPercent) / 100)
    },
    isBonusServiceActive () {
      return this.config.service?.is_bonus_service_active
    }
  }
}
</script>

<style scoped lang="sass">

.bonus-info
  display: flex
  align-items: center
  flex-flow: row nowrap
  width: max-content
  border-radius: 3px

.bonus-info__text
  padding: 0
  margin: 0 15px 0 0
  color: $text-color
  font-weight: 400
  font-size: 14px

.bonus-info__icon
  display: block
  width: 100%
  max-width: 24px
  object-fit: contain
  margin: 0 10px 0 0
  pointer-events: none
</style>
